import { Spacing } from '../../design-system/spacing';
import { styled } from '../../utils/styled';
import { Button } from '../Button';
import { Field } from '../Field';
import { Stack } from '../Stack';

//TODO showError prop should put border color red when error is true
export const InputContainer = styled(Field, {
  shouldForwardProp: (prop) => prop !== 'showError',
})<{ showError?: boolean }>`
  margin: 0;
  max-width: 100%;
  max-height: 56px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border: 1px solid
    ${({ theme, showError }) =>
      showError ? theme.palette.red[600] : theme.palette.neutral[200]};

  .MuiInputBase-input {
    box-sizing: border-box;
    height: 54px;
  }
  .MuiOutlinedInput-notchedOutline {
    border-radius: unset;
    border: unset;
  }
  .MuiOutlinedInput-input {
    cursor: default;
    :hover {
      border-color: ${({ theme }) => theme.palette.neutral[200]};
    }
    padding: ${({ theme }) => theme.spacing(Spacing.Medium)};
    border-left: unset;
    border-right: unset;
    text-align: center;
  }
  :hover .MuiInputBase-root input:not(:active) {
    border-color: ${({ theme }) => theme.palette.neutral[200]};
  }
  :hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) => theme.palette.neutral[200]};
  }
  :hover .MuiInputBase-input,
  :hover {
    background-color: ${({ theme }) => theme.palette.neutral[100]};
  }
`;

export const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'showError',
})<{ showError?: boolean }>`
  display: flex;
  width: 56px;
  height: 56px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  color: ${({ theme, showError }) =>
    showError ? theme.palette.red[600] : theme.palette.primary.main};
  :disabled {
    border: 1px solid ${({ theme }) => theme.palette.neutral[200]};
  }

  :hover {
    background-color: ${({ theme, showError }) =>
      showError ? theme.palette.error.light : theme.palette.primary.light};
  }

  :first-of-type {
    border-top: 1px solid
      ${({ theme, showError }) =>
        showError ? theme.palette.red[600] : theme.palette.neutral[200]};
    border-bottom: 1px solid
      ${({ theme, showError }) =>
        showError ? theme.palette.red[600] : theme.palette.neutral[200]};
    border-right: unset;
    border-left-color: ${({ theme, showError }) =>
      showError ? theme.palette.red[600] : theme.palette.neutral[200]};
    border-top-right-radius: unset;
    border-bottom-right-radius: unset;
  }
  :last-of-type {
    border-right-color: ${({ theme, showError }) =>
      showError ? theme.palette.red[600] : theme.palette.neutral[200]};
    border-top: 1px solid
      ${({ theme, showError }) =>
        showError ? theme.palette.red[600] : theme.palette.neutral[200]};
    border-bottom: 1px solid
      ${({ theme, showError }) =>
        showError ? theme.palette.red[600] : theme.palette.neutral[200]};
    border-left: unset;
    border-top-left-radius: unset;
    border-bottom-left-radius: unset;
  }
`;

export const GroupContainer = styled(Stack)`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;
